import { createSlice } from "@reduxjs/toolkit";
import { addWallet, getWallet } from "../../api/wallet";

const initialState = {
  isLoading: false,
  isAdded: false,
  wallet: null,
  variantRowEdit: [],
};

export const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    getVariantEditedRow: (state, { payload }) => {
      state.variantRowEdit = payload;
    },
  },
  extraReducers: {
    [addWallet.pending]: (state) => {
      state.isLoading = true;
    },
    [addWallet.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isAdded = true;
    },
    [addWallet.rejected]: (state) => {
      state.isLoading = false;
    },
    [getWallet.pending]: (state) => {
      state.isLoading = true;
    },
    [getWallet.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.wallet = payload;
    },
    [getWallet.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { getVariantEditedRow } = walletSlice.actions;
export const walletSelector = (state) => state.wallet;
export default walletSlice.reducer;
